import { tickerLines } from "@/mocks/homeContent";

const entries = [
  { label: "索引", href: "#index" },
  { label: "快讯流", href: "#timeline" },
  { label: "问答", href: "#faq" },
  { label: "反馈", href: "#feedback" },
];

export default function TopTicker() {
  const strip = [...tickerLines, ...tickerLines];

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-12 items-center gap-3 md:gap-5">
          <a href="#top" className="flex shrink-0 cursor-pointer items-center gap-2">
            <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-500 font-heading text-xs font-bold text-background-50">
              黑
            </span>
            <span className="font-heading text-sm font-semibold tracking-wide text-foreground-950">
              黑料网站
            </span>
          </a>

          <span className="hidden h-4 w-px bg-background-300 md:block" />

          <div className="hidden min-w-0 flex-1 items-center gap-2 md:flex">
            <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-100 px-2 py-0.5 text-[11px] font-semibold text-primary-700">
              <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-primary-500" />
              更新条
            </span>
            <div className="relative flex-1 overflow-hidden">
              <div className="flex w-max animate-drift-line items-center">
                {strip.map((line, i) => (
                  <span
                    key={`${line}-${i}`}
                    className="flex items-center whitespace-nowrap px-4 text-xs text-foreground-600"
                  >
                    {line}
                    <span className="ml-4 text-background-400">/</span>
                  </span>
                ))}
              </div>
            </div>
          </div>

          <nav className="ml-auto flex items-center gap-1 text-xs md:gap-1.5 md:text-sm">
            {entries.map((e) => (
              <a
                key={e.href}
                href={e.href}
                className="cursor-pointer whitespace-nowrap rounded-md px-2.5 py-1.5 text-foreground-600 transition-colors hover:bg-secondary-100 hover:text-foreground-950 md:px-3"
              >
                {e.label}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
}